import React, { useState, useEffect } from "react";
import { FaFileExcel, FaFilter, FaTrash } from "react-icons/fa";
import DatePicker from "react-datepicker";
import * as XLSX from "xlsx";
import { motion } from "framer-motion";
import Layout, { Container } from "../components/layout";
import { apiurl } from "../config/config";
import { SuwasthiLoader } from "../components/loader";
import Pagination from "../components/pagination";
import AssignRoleModal from "../components/assignRoleModal";
import Breadcrumb from "../components/breadcrumb";
import { Link } from "react-router-dom";
import { useUser } from "../config/userProvider";
import axios from "axios";

const Employees = () => {
  const [employees, setEmployees] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [selectedEmployees, setSelectedEmployees] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [itemsPerPage, setItemsPerPage] = useState(100);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [filterStatus, setFilterStatus] = useState("");
  const [verificationStatus, setVerificationStatus] = useState("");
  // const [employeeStatus, setEmployeeStatus] = useState("");
  const [employeeStatus, setEmployeeStatus] = useState([]);
  const [filterModalOpen, setFilterModalOpen] = useState(false);
  const [paginationData, setPaginationData] = useState("");
  const [totalPages, setTotalPages] = useState(1);
  const [statusCounts, setStatusCounts] = useState({});

  const { userData } = useUser();

  // useEffect(() => {
  //   fetchEmployees();
  // }, [currentPage, itemsPerPage]);

  // const fetchEmployees = () => {
  //   setLoading(true);
  //   fetch(
  //     `${apiurl}/api/employee/filter?page=${currentPage}&limit=${itemsPerPage}`
  //   )
  //     .then((res) => res.json())
  //     .then((data) => {
  //       // console.log("Fetched employees:", data);
  //       setEmployees(data.employees);
  //       setTotalItems(data.pagination?.totalItems || 0);
  //       setLoading(false);
  //       setSelectedEmployees([]);
  //       setSelectAll(false);
  //     })
  //     .catch((err) => {
  //       console.error("Error fetching employees:", err);
  //       setLoading(false);
  //     });
  // };

  useEffect(() => {
    fetchEmployees();
  }, [currentPage, itemsPerPage, search, startDate, endDate]);

  const fetchEmployees = () => {
    setLoading(true);

    // Build query params dynamically
    const params = new URLSearchParams();
    params.append("page", currentPage);
    params.append("limit", itemsPerPage);

    if (search) {
      params.append("search", search);
    }

    if (startDate) {
      params.append("startDate", startDate.toISOString().split("T")[0]); // yyyy-mm-dd format
    }

    if (endDate) {
      params.append("endDate", endDate.toISOString().split("T")[0]);
    }

    // If you want to add employeeStatus filter, add a state and append here
    // if (employeeStatus) {
    //   params.append("employeeStatus", employeeStatus);
    // }

    fetch(`${apiurl}/api/employee/filter?${params.toString()}`)
      .then((res) => res.json())
      .then((data) => {
        setEmployees(data.employees);
        setTotalItems(data.pagination?.totalItems || 0);
        setLoading(false);
        setSelectedEmployees([]);
        setSelectAll(false);
        setStatusCounts(data.employeeStatusCount);
      })
      .catch((err) => {
        console.error("Error fetching employees:", err);
        setLoading(false);
      });
  };

  const handleLimitChange = (e) => {
    setItemsPerPage(Number(e.target.value));
    setCurrentPage(1);
  };

  const handleCheckboxChange = (employeeId) => {
    setSelectedEmployees((prev) =>
      prev.includes(employeeId)
        ? prev.filter((id) => id !== employeeId)
        : [...prev, employeeId]
    );
  };

  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedEmployees([]);
    } else {
      setSelectedEmployees(employees.map((emp) => emp._id));
    }
    setSelectAll(!selectAll);
  };

  const filteredEmployees = employees.filter((emp) => {
    const lowerSearch = search.toLowerCase();

    return (
      emp?.personalDetails?.firstName?.toLowerCase().includes(lowerSearch) ||
      emp?.personalDetails?.lastName?.toLowerCase().includes(lowerSearch) ||
      emp?.personalDetails?.email?.toLowerCase().includes(lowerSearch) ||
      emp?.personalDetails?.aadharNumber?.toLowerCase().includes(lowerSearch) ||
      emp?.employeeId?.toLowerCase().includes(lowerSearch) ||
      emp?.employeeCode?.toLowerCase().includes(lowerSearch)
    );
  });

  const listVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: (index) => ({
      opacity: 1,
      y: 0,
      transition: { delay: index * 0.05, duration: 0.3 },
    }),
  };

  console.log("selectedEmployees", selectedEmployees);

  const handleDeleteSelected = async () => {
    if (
      !window.confirm("Are you sure you want to delete the selected employees?")
    )
      return;

    try {
      const response = await fetch(`${apiurl}/api/employee/bulk-delete`, {
        method: "DELETE",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ employeeObjIds: selectedEmployees }),
      });

      const result = await response.json();

      if (response.ok) {
        alert(result.message || "Employees deleted successfully.");
        fetchEmployees();
      } else {
        alert(result.error || "Failed to delete employees.");
      }
    } catch (error) {
      console.error("Delete error:", error);
      alert("An error occurred while deleting employees.");
    }
  };

  // sendEmployeeMail.ts

  const sendEmployeeMail = async () => {
    try {
      const response = await axios.post(
        `${apiurl}/api/employee/send-employee-mail`,
        {
          employeeEmail: userData?.email,
          employeeName: userData?.firstName + " " + userData?.lastName,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      console.log("Mail sent successfully:", response.data);
      return response.data;
    } catch (error) {
      console.error("Error sending mail:", error);
      throw error;
    }
  };

  const exportToExcel = () => {
    sendEmployeeMail();
    let dataToExport = employees;

    if (selectedEmployees.length > 0) {
      dataToExport = dataToExport.filter((emp) =>
        selectedEmployees.includes(emp._id)
      );
    }

    if (dataToExport.length === 0) {
      alert("No employee data found for export.");
      return;
    }

    const uppercase = (value) => {
      return typeof value === "string" ? value.toUpperCase() : value;
    };

    const capitalize = (value) => {
      return typeof value === "string"
        ? value
            .split(/(\s+)/) // split by spaces, keeping the separators
            .map((word) =>
              word.trim()
                ? word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
                : word
            )
            .join("")
        : value;
    };
    function buildAddress(addressObj) {
      if (!addressObj) return "";

      const {
        address1 = "",
        address2 = "",
        city = "",
        province = "",
        zipCode = "",
        country = "",
        provinceCode = "",
        countryCode = "",
        landmark = "",
      } = addressObj;

      const parts = [
        address1,
        address2,
        landmark,
        city,
        province,
        provinceCode,
        zipCode,
        country,
        countryCode,
      ].filter(Boolean); // removes empty strings

      return capitalize(parts.join(", ").trim());
    }

    const normalizeId = (rawId) => {
      if (!rawId) return "";
      const match = rawId.toUpperCase().match(/(SUW)[\s\-]?(\d+)/);
      return match ? `${match[1]}${match[2]}` : rawId.toUpperCase();
    };

    const flattenEmployeeData = (emp, index) => {
      return {
        SNO: index + 1,
        "Application ID": emp?.applicationDetails?.applicationId || "",
        "EMPLOYEE ID": uppercase(emp.employeeCode || ""),
        NAME: capitalize(
          `${emp.personalDetails.firstName} ${emp.personalDetails.lastName}` ||
            ""
        ),
        DESIGNATION: capitalize(emp.designation || ""),
        DEPARTMENT: capitalize(emp.department || ""),
        "CONTACT NO": capitalize(emp.personalDetails.phone || ""),
        EMAIL: capitalize(emp.personalDetails.email || ""),
        DOB: emp.personalDetails.dateOfBirth
          ? new Date(emp.personalDetails.dateOfBirth).toLocaleDateString(
              "en-GB"
            )
          : "",
        "Marital Status": capitalize(emp.personalDetails.maritalStatus || ""),

        "Aadhar Number": normalizeId(emp.identification.aadharNumber || ""),
        "PAN Number": normalizeId(emp.identification.panNumber || ""),
        "Employee Status": capitalize(emp.employeeStatus || ""),
        "Joining Date": emp.employeeJoiningDate
          ? new Date(emp.employeeJoiningDate).toLocaleDateString("en-GB")
          : "",

        "Reporting Manager Name": capitalize(
          emp.reportingDetails.managerName || ""
        ),

        "Emergency Contact Name": capitalize(
          emp.emergencyContactDetails.emergencyContactName || ""
        ),
        "Emergency Contact Number": capitalize(
          emp.emergencyContactDetails.emergencyContactPhone || ""
        ),
        "Emergency Contact Relation": capitalize(
          emp.emergencyContactDetails.emergencyContactRelationship || ""
        ),

        "Bank Name": capitalize(emp.bankDetails.bankName || ""),
        "Account Holder Name": capitalize(
          emp.bankDetails.accountHolderName || ""
        ),
        "Account Number": normalizeId(emp.bankDetails.accountNumber || ""),
        "IFSC Code": normalizeId(emp.bankDetails.ifscCode || ""),
        "Branch Name": capitalize(emp.bankDetails.branchName || ""),

        "Monthly Salary": capitalize(
          emp.offerDetails.salaryDetails.monthlySalary || ""
        ),
        "Permanent Address": buildAddress(
          emp.personalDetails?.permanentAddress
        ),
        "Current Address": buildAddress(emp.personalDetails?.currentAddress),
        "Document Verification Status": emp?.verificationStatus.toUpperCase() || "",
      };
    };

    const formattedData = dataToExport.map(flattenEmployeeData);

    const worksheet = XLSX.utils.json_to_sheet(formattedData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "employees");

    const fileName = `employees-${new Date().toISOString().split("T")[0]}.xlsx`;
    XLSX.writeFile(workbook, fileName);
  };

  const fetchFilterEmployees = () => {
    setLoading(true);
    let url = `${apiurl}/api/employee/filter?page=${currentPage}&limit=${itemsPerPage}`;

    const formatDate = (date) => {
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      return `${year}-${month}-${day}`;
    };

    if (startDate) url += `&startDate=${formatDate(startDate)}`;
    if (endDate) url += `&endDate=${formatDate(endDate)}`;
    if (employeeStatus) url += `&employeeStatus=${employeeStatus}`;
    if (verificationStatus) url += `&verificationStatus=${verificationStatus}`;

    fetch(url)
      .then((res) => res.json())
      .then((data) => {
        setEmployees(data.employees);
        setTotalItems(data.pagination?.totalItems || 0);
        setTotalPages(data.totalPages);
        setLoading(false);
        setPaginationData(data?.pagination);
        setSelectAll(false);
        setSelectedEmployees([]);
      })
      .catch((err) => {
        console.error("Error fetching applications:", err);
        setLoading(false);
      });
  };

  const statusColorMap = {
    active: "text-green-600 bg-green-100",
    inactive: "text-gray-600 bg-gray-100",
    resigned: "text-yellow-600 bg-yellow-100",
    absconded: "text-red-600 bg-red-100",
    terminated: "text-pink-600 bg-pink-100",
    All: "text-blue-600 bg-blue-100",
  };

  const hasReadPermission = (permissions, resourceKey) => {
    const perm = permissions?.find((p) => p.resource === resourceKey);
    return perm?.read === true;
  };
  return (
    <Layout>
      {/* <Breadcrumb /> */}
      <Container overflow="overflow-scroll">
        <div className="p-2 bg-gray-100">
          {/* <div className="p-2 bg-gray-100"> */}
          <div className="flex w-full divide-x rounded-md overflow-hidden border mb-1">
            {Object.entries(statusCounts).map(([status, count]) => (
              <div
                key={status}
                className={`flex-1 px-3 py-2 text-center ${
                  statusColorMap[status] || "text-black bg-gray-200"
                }`}
              >
                <div className="text-[11px] capitalize">{status}</div>
                <div className="text-[13px] font-semibold">{count}</div>
              </div>
            ))}
          </div>
          {/* </div> */}

          <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-2 gap-1">
            <input
              type="text"
              placeholder="Search by name, email, employee ID, code, or Aadhar"
              className="p-2 border rounded w-full md:w-1/3"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
            {/* <DatePicker
              selected={startDate}
              onChange={setStartDate}
              placeholderText="Start Date"
              className="p-2 border rounded"
            />
            <DatePicker
              selected={endDate}
              onChange={setEndDate}
              placeholderText="End Date"
              className="p-2 border rounded"
            /> */}

            <div className="flex flex-wrap gap-2 justify-start md:justify-end items-center w-full md:w-auto">
              {/* <p className="bg-blue-100 text-blue-800 text-xs font-medium me-2 px-2.5 py-2 rounded-sm dark:bg-blue-900 dark:text-blue-300">
                {employees?.length}
              </p> */}

                            <Link
                to="/employees/document-summary"
                className="text-white bg-purple-600 hover:bg-purple-700 focus:ring-4 focus:ring-purple-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 dark:bg-purple-500 dark:hover:bg-purple-600 focus:outline-none dark:focus:ring-purple-800 flex items-center gap-2"
              >
                Document Summary
              </Link>
              <button
                onClick={() => setFilterModalOpen(true)}
                className="flex items-center gap-2 px-4 py-2 rounded-lg text-white bg-blue-500 hover:bg-blue-600 transition"
              >
                <FaFilter /> Filter
              </button>
              {hasReadPermission(
                userData.permissions,
                "download_employees"
              ) && (
                <button
                  className={`flex items-center gap-2 px-4 py-2 rounded-lg text-white bg-green-500 hover:bg-green-600 transition ${
                    selectedEmployees.length === 0
                      ? "opacity-50 cursor-not-allowed"
                      : ""
                  }`}
                  onClick={exportToExcel}
                  disabled={selectedEmployees.length === 0}
                >
                  <FaFileExcel /> {selectedEmployees?.length} Download
                </button>
              )}

              {/* {selectedEmployees.length > 0 && (
              <button
                className="bg-red-600 text-white px-4 py-2 rounded flex items-center gap-2"
                onClick={handleDeleteSelected}
              >
                <FaTrash /> Delete Selected
              </button>
            )} */}

              <Link
                to="/employees/create"
                className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800"
              >
                Create
              </Link>

              <select
                className="p-2 border rounded"
                value={itemsPerPage}
                onChange={handleLimitChange}
              >
                <option value="100">100</option>
                <option value="200">200</option>
                <option value="500">500</option>
                <option value="1000">1000</option>
                <option value="2000">2000</option>
                <option value="5000">5000</option>
              </select>
              {/* {selectedEmployees.length > 0 && (
              <button
                className="bg-red-500 hover:bg-red-600 text-white px-4 py-2 rounded"
                onClick={() => setIsModalOpen(true)}
              >
                Assign Role
              </button>
            )} */}
            </div>
          </div>

          {loading ? (
            <SuwasthiLoader />
          ) : (
            <div className="bg-white shadow-md rounded-lg p-4 overflow-x-auto">
              <table className="w-full border-collapse">
                <thead>
                  <tr className="bg-gray-200 text-sm">
                    <th className="p-3">
                      <input
                        type="checkbox"
                        checked={selectAll}
                        onChange={handleSelectAll}
                      />
                    </th>
                    <th className="p-3 text-left">HRMS ID</th>
                    <th className="p-3 text-left">Employee ID</th>
                    <th className="p-3 text-left">Name</th>
                    <th className="p-3 text-left">Email</th>
                    <th className="p-3 text-left">Veriffication</th>
                    <th className="p-3 text-left">Verified By</th>
                    <th className="p-3 text-left">Status</th>
                    <th className="p-3 text-left">Onboard By</th>
                    <th className="p-3 text-left">Actions</th>
                  </tr>
                </thead>
                <tbody className="text-sm">
                  {employees.map((employee, index) => (
                    <motion.tr
                      key={employee._id}
                      className="border-b"
                      variants={listVariants}
                      initial="hidden"
                      animate="visible"
                      custom={index}
                    >
                      <td className="p-3">
                        <input
                          type="checkbox"
                          checked={selectedEmployees.includes(employee._id)}
                          onChange={() => handleCheckboxChange(employee._id)}
                        />
                      </td>
                      <td className="p-3">{employee.id}</td>
                      <td className="p-3">{employee.employeeCode}</td>
                      {/* <td className="p-3">{employee.employeeId}</td> */}
                      <td className="p-3">
                        {employee?.personalDetails?.firstName}{" "}
                        {employee?.personalDetails?.lastName}
                      </td>
                      <td className="p-3">
                        {employee?.personalDetails?.email}
                      </td>
                      {/* <td className="p-3">{employee?.verificationStatus}</td>
                      <td className="p-3">{employee?.employeeStatus}</td> */}
                      <td className="p-3">
                        <span
                          className={`px-2 py-1 text-xs font-semibold rounded-full ${
                            employee.verificationStatus === "verified"
                              ? "bg-green-100 text-green-700"
                              : employee.verificationStatus === "rejected"
                              ? "bg-red-100 text-red-700"
                              : "bg-yellow-100 text-yellow-700"
                          }`}
                        >
                          {employee.verificationStatus?.toUpperCase() || "N/A"}
                        </span>
                      </td>
                      <td>{employee.verificationBy?.userName || "N/A"}</td>

                      <td className="p-3">
                        <span
                          className={`px-2 py-1 text-xs font-semibold rounded-full ${
                            employee.employeeStatus === "active"
                              ? "bg-green-100 text-green-700"
                              : employee.employeeStatus === "inactive"
                              ? "bg-red-100 text-red-700"
                              : employee.employeeStatus === "terminated"
                              ? "bg-yellow-100 text-yellow-700"
                              : employee.employeeStatus === "resigned"
                              ? "bg-gray-100 text-gray-700"
                              : "bg-blue-100 text-blue-700"
                          }`}
                        >
                          {employee.employeeStatus?.toUpperCase() || "N/A"}
                        </span>
                      </td>
                      <td>
                        {employee.createdBy?.userName || "N/A"}
                        <br />
                        {employee.createdAt
                          ? new Date(employee.createdAt).toLocaleString(
                              "en-IN",
                              {
                                day: "2-digit",
                                month: "short",
                                year: "numeric",
                                hour: "2-digit",
                                minute: "2-digit",
                              }
                            )
                          : "N/A"}
                      </td>

                      <td className="p-3">
                        <Link
                          className="border text-blue-600 border-blue-600 hover:bg-blue-50 rounded-md px-3 py-1"
                          to={`/employees/${employee?._id}`}
                        >
                          View
                        </Link>
                      </td>
                    </motion.tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          {isModalOpen && (
            <AssignRoleModal
              isModalOpen={isModalOpen}
              setIsModalOpen={setIsModalOpen}
              selectedApplications={selectedEmployees}
            />
          )}

          {filterModalOpen && (
            <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
              <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-md">
                <h2 className="text-xl font-semibold mb-4">Filter Employees</h2>

                <div className="mb-4">
                  <label className="block text-sm mb-1">Start Date:</label>
                  <DatePicker
                    selected={startDate}
                    onChange={setStartDate}
                    placeholderText="Start Date"
                    className="p-2 border rounded w-full"
                  />
                </div>

                <div className="mb-4">
                  <label className="block text-sm mb-1">End Date:</label>
                  <DatePicker
                    selected={endDate}
                    onChange={setEndDate}
                    placeholderText="End Date"
                    className="p-2 border rounded w-full"
                  />
                </div>

                <div className="mb-4">
                  <label className="block text-sm mb-1">
                    Verification Status:
                  </label>
                  <select
                    value={verificationStatus}
                    onChange={(e) => setVerificationStatus(e.target.value)}
                    className="p-2 border rounded w-full"
                  >
                    <option value="">All</option>
                    <option value="pending">Pending</option>
                    <option value="verified">Verified</option>
                    <option value="rejected">Rejected</option>
                  </select>
                </div>

                {/* <div className="mb-4">
                  <label className="block text-sm mb-1">Employee Status:</label>
                  <select
                    value={employeeStatus}
                    onChange={(e) => setEmployeeStatus(e.target.value)}
                    className="p-2 border rounded w-full"
                  >
                    <option value="">All</option>
                    <option value="active">Active</option>
                    <option value="inactive">Inactive</option>
                  </select>
                </div> */}

                <div className="mb-4">
                  <label className="block text-sm font-medium mb-1">
                    Employee Status:
                  </label>
                  <div className="space-y-1">
                    {/* All Option */}
                    <label className="flex items-center space-x-2">
                      <input
                        type="checkbox"
                        value="all"
                        checked={employeeStatus.length === 0}
                        onChange={(e) => {
                          if (e.target.checked) {
                            setEmployeeStatus([]); // "All" selected means clear all filters
                          }
                        }}
                        disabled={employeeStatus.length > 0} // disable "All" if any status is selected
                      />
                      <span className="text-sm">All</span>
                    </label>

                    {/* Specific Status Options */}
                    {["active", "inactive", "terminated", "resigned"].map(
                      (status) => (
                        <label
                          key={status}
                          className="flex items-center space-x-2"
                        >
                          <input
                            type="checkbox"
                            value={status}
                            checked={employeeStatus.includes(status)}
                            onChange={(e) => {
                              const value = e.target.value;
                              setEmployeeStatus((prev) => {
                                const updated = prev.includes(value)
                                  ? prev.filter((s) => s !== value)
                                  : [...prev, value];
                                return updated; // empty array = "All" selected automatically
                              });
                            }}
                          />
                          <span className="text-sm capitalize">{status}</span>
                        </label>
                      )
                    )}
                  </div>
                </div>

                <select
                  className="p-2 border rounded"
                  value={itemsPerPage}
                  onChange={handleLimitChange}
                >
                  <option value="100">100</option>
                  <option value="500">500</option>
                  <option value="1000">1000</option>
                  <option value="2000">2000</option>
                  <option value="5000">5000</option>
                </select>

                <div className="flex justify-end gap-2">
                  <button
                    className="bg-gray-300 text-black px-4 py-2 rounded"
                    onClick={() => {
                      setStartDate(null);
                      setEndDate(null);
                      // setEmployeeStatus("");
                      setEmployeeStatus([]);
                      setVerificationStatus("");
                      fetchEmployees();
                    }}
                  >
                    Clear Filters
                  </button>

                  <button
                    onClick={() => setFilterModalOpen(false)}
                    className="px-4 py-2 rounded bg-gray-300 hover:bg-gray-400"
                  >
                    Cancel
                  </button>
                  <button
                    onClick={() => {
                      setFilterModalOpen(false);
                      fetchFilterEmployees(); // you can also add filter logic here
                    }}
                    className="px-4 py-2 rounded bg-green-600 hover:bg-green-700 text-white"
                  >
                    Apply
                  </button>
                </div>
              </div>
            </div>
          )}

          <Pagination
            currentPage={currentPage}
            totalItems={totalItems}
            itemsPerPage={itemsPerPage}
            onPageChange={setCurrentPage}
          />
        </div>
      </Container>
    </Layout>
  );
};

export default Employees;